import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';

const IdleTimer = forwardRef(({ timeout = 0, onIdle }, ref) => {
  const idleTimer = useIdleTimer({
    onIdle,
    timeout,
    throttle: 500,
  });
  const idleTimerRef = useRef(idleTimer);

  useImperativeHandle(ref, () => ({
    start: idleTimerRef.current.start,
    reset: idleTimerRef.current.pause,
  }));

  return null;
});

export default IdleTimer;
